module.exports = __webpack_public_path__ + "static/media/Throh_gaussian2.e698f40c.png";